import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mr-note-form',
  templateUrl: './mr-note-form.component.html',
  styleUrls: ['./mr-note-form.component.css']
})
export class MrNoteFormComponent implements OnInit {
  title="Material Receipt Note";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/purchase/material-receipt-note/mr-note-form/mr-note-form.component.ts